"use client";

import Image from "next/image";
import { Container, Row, Col, Button } from "react-bootstrap";
import styles from "./WhyTemokSection.module.css";

import whyVect from "@/app/assets/whyvect.png";     // replace with your card image
import whyTmk from "@/app/assets/whytmk.svg";     // replace with your card image
import Check from "@/app/assets/check.svg";     // replace with your card image
import Link from "next/link";
// import cloudIcon from "@/app/assets/cloud.svg";        // replace icons
// import starIcon from "@/app/assets/star.svg";

export default function WhyTemokSection() {
  return (
    <section className={styles.section}>
      <Container>
      <div className={styles.header}>
          <div className={styles.leftBlock}>
            <span className={styles.icon}>
              <Image src={whyTmk} width={30} alt="..." />
            </span>
            <span className={styles.titleWhy}>Why Temok</span>
          </div>
        </div>
        <Row className="align-items-center">

          {/* ========= LEFT SIDE ========= */}
          <Col lg={6} >
            <div className={styles.cardWrapper}>
              <Image
                src={whyVect}
                alt="VPS Plan"
                className={styles.cardImage}
              />
 
            </div> 
          </Col>

          {/* ========= RIGHT SIDE ========= */}
          <Col lg={6} >
            <div className={styles.rightCol}>
            <h2 className={styles.title}>Build Smarter.<br />Host Better.</h2>

            <p className={styles.para}>
              Let our AI guide you through a fast, visual setup.  
              From apps and storage to global locations — everything tailored to your needs.
            </p>

            <ul className={styles.list}>
              <li><Image src={Check} width={24} height={24} alt="..."/> Visual product builder with instant pricing</li>
              <li><Image src={Check} width={24} height={24} alt="..."/> Data center locations across continents</li>
              <li><Image src={Check} width={24} height={24} alt="..."/> Fully customizable with real-time previews</li>
            </ul>
<Link href="http://ai.temok.com/" className="text-decoration-none" target="_blank">
            <Button className={styles.ctaBtn}  onClick={() => window.openVFChat()} >
              Start Building with AI →
            </Button>
            </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
